var n,r;!function(n){n.LEFT="left",n.RIGHT="right"}(n||(n={})),function(n){n.SUCCESS="success",n.ERROR="error",n.WARNING="warning",n.BRAND="brand",n.INFO="info",n.MODERN="modern"}(r||(r={}));export{n as BadgePositionEnum,r as BadgeVariantsEnum};
//# sourceMappingURL=badge.types.js.map
